import styles from "./index.module.scss";
import Select from "react-select";
import { useState, useRef, useCallback, useEffect } from "react";
import { Button } from "react-bootstrap";

const StandingsSearch = ({ user, items, setItems, reset }) => {
  const [selectedUser, setSelectedUser] = useState();
  const [expanded, setExpanded] = useState(false);
  const [mode, setMode] = useState("all");
  const itemsSnapshot = useRef([]);

  useEffect(() => {
    //itemsSnapshot.current = [];
    setSelectedUser(null);
    //setItems([]);
    //setMode("all");
  }, [setItems, reset]);

  const onChange = (selectedOption) => {
    const option = items.find(
      (option) =>
        option.value === (selectedOption ? selectedOption?.value : null)
    );

    setSelectedUser(option);
    searchUser(selectedOption);
  };

  const searchUser = useCallback(
    (selectedOption) => {
      if (mode === "all") {
        itemsSnapshot.current = items;
      }
      if (selectedOption !== null) {
        setMode("user");
        setItems(items.filter((item) => item.UserId === selectedOption?.value));
      } else {
        setItems(itemsSnapshot.current);
        setMode("all");
      }
    },
    [mode, itemsSnapshot, setItems, items]
  );

  return (
    <div className={styles.searchBox}>
      {!expanded ? (
        <Button
          size="sm"
          variant="light"
          onClick={() => setExpanded((prev) => !prev)}
          className={styles.text}
        >
          <i className="bi bi-search"></i>&nbsp;Пошук учасників
        </Button>
      ) : (
        <Select
          autoFocus={true}
          isClearable={true}
          maxMenuHeight={200}
          value={selectedUser}
          options={items
            .map(({ UserId, FullName }) => ({
              label: FullName,
              value: UserId,
              me: user?.me?.userId === UserId,
            }))
            .sort((a, b) => b.me - a.me || a.label.localeCompare(b.label))}
          onChange={onChange}
          placeholder="Введіть ім'я"
          noOptionsMessage={() => "Не знайдено"}
          className={styles.search}
        />
      )}
    </div>
  );
};

export default StandingsSearch;
